import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { PageHero, SectionHeading, Overline } from "@/components/ui-kit";
import LeadForm from "@/components/LeadForm";
import { useSeo } from "@/lib/useSeo";
import { BUSINESS } from "@/lib/config";

export default function Contact() {
  useSeo({ title: "Contact", description: "Visit or reach the Sutra Interio studio in Kolkata. Call, WhatsApp or book a consultation." });
  return (
    <div data-testid="contact-page">
      <PageHero overline="Get in Touch" title="Let&apos;s begin a" italic="conversation."
        sub="Reach us directly, or share your project details and a Relationship Manager will connect within 24 hours." />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-16 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <SectionHeading overline="Studio" title="Sutra Interio," italic="Kolkata." />
          <div className="mt-8 space-y-6">
            {[
              [MapPin, "Address", BUSINESS.address, null],
              [Phone, "Phone", BUSINESS.phone, `tel:${BUSINESS.phoneRaw}`],
              [Mail, "Email", BUSINESS.email, `mailto:${BUSINESS.email}`],
              [Clock, "Hours", "Mon – Sat · 10:00 AM – 7:00 PM", null],
            ].map(([Icon, l, v, href], i) => (
              <Reveal key={l} delay={i * 0.06} className="flex gap-4">
                <Icon className="text-bronze shrink-0 mt-1" size={20} />
                <div>
                  <Overline>{l}</Overline>
                  {href ? <a href={href} className="block mt-1 hover:text-bronze transition-colors">{v}</a> : <p className="mt-1 text-ink/80">{v}</p>}
                </div>
              </Reveal>
            ))}
            <Reveal className="flex gap-4">
              <Star className="text-bronze shrink-0 mt-1" size={20} fill="currentColor" />
              <div><Overline>Google Rating</Overline><p className="mt-1 text-ink/80">{BUSINESS.rating} / 5 · {BUSINESS.reviewCount}+ reviews</p></div>
            </Reveal>
          </div>
          <Reveal className="mt-10 flex gap-4">
            <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp"
              className="bg-[#25D366] text-white text-sm uppercase tracking-[0.2em] font-bold px-6 py-3.5 rounded-sm hover:opacity-90 transition-opacity">WhatsApp Us</a>
            <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="contact-call"
              className="border border-olive/40 text-sm uppercase tracking-[0.2em] font-bold px-6 py-3.5 rounded-sm hover:bg-olive hover:text-beige transition-colors">Call Now</a>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal className="lg:pl-10 lg:border-l border-olive/15">
            <h3 className="font-display text-3xl mb-8">Send an enquiry</h3>
            <LeadForm variant="full" source="Contact Page" />
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24">
        <Reveal className="overflow-hidden rounded-md border border-gold/20">
          <iframe title="Sutra Interio location" src={BUSINESS.mapEmbed} data-testid="contact-map"
            className="w-full h-[380px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
        </Reveal>
      </section>
    </div>
  );
}
